let mainPath = "/admin";
//auth
export const login = "/admin/login";
export const forgot_password = "/admin/forgot_password";
export const reset_password = "/admin/reset_password/:token";

//auth
export const dashboard = `${mainPath}/dashboard`;

//profile
export const profile = `${mainPath}/profile`;
export const change_password = `${mainPath}/change_password`;

//contact_support
export const contact_support = `${mainPath}/contact_support`;

//transaction
export const transaction = `${mainPath}/transaction/listing`;
export const transaction_view = `${mainPath}/transaction/detail`;
//cms
export const cms = `${mainPath}/content_page`;
export const cms_form = `${mainPath}/content_page/form`;
export const cmsform = `${mainPath}/content_page/form/:key`;
export const cms_Page = "/cms";
export const cmsPage = `/cms/:key`;
//FAQ
export const faq = `${mainPath}/faq`;
export const faq_form = `${mainPath}/faq/form`;
export const faqform = `${mainPath}/faq/form/:id`;

//system_access
export const system_access = `${mainPath}/system_access/listing`;
export const system_access_view = `${mainPath}/system_access/detail/:id`;
export const system_access_add = `${mainPath}/system_access/add`;
export const system_access_edit = `${mainPath}/system_access/edit`;
export const system_accessedit = `${mainPath}/system_access/edit/:id`;
export const system_accessview = `${mainPath}/system_access/detail`;

//users
export const users = `${mainPath}/user/listing`;
export const user_view = `${mainPath}/user/detail/:id`;
export const user_add = `${mainPath}/user/add`;
export const user_edit = `${mainPath}/user/edit`;
export const useredit = `${mainPath}/user/edit/:id`;
export const userview = `${mainPath}/user/detail`;

export const userdeatil = `${mainPath}/user/listing`;
export const usermatches = `${mainPath}/user/preferences`;

//coach
export const coach = `${mainPath}/coach/listing`;
export const coach_view = `${mainPath}/coach/detail/:id`;
export const coach_add = `${mainPath}/coach/add`;
export const coach_edit = `${mainPath}/coach/edit`;
export const coachedit = `${mainPath}/coach/edit/:id`;
export const coachview = `${mainPath}/coach/detail`;
//category
export const category = `${mainPath}/category/listing`;
export const category_view = `${mainPath}/category/detail/:id`;
export const category_add = `${mainPath}/category/add`;
export const category_edit = `${mainPath}/category/edit`;
export const categoryedit = `${mainPath}/category/edit/:id`;
export const categoryview = `${mainPath}/category/detail`;
//post
export const post = `${mainPath}/post/listing`;
export const post_view = `${mainPath}/post/detail/:id`;
export const post_add = `${mainPath}/post/add`;
export const post_edit = `${mainPath}/post/edit`;
export const postedit = `${mainPath}/post/edit/:id`;
export const postview = `${mainPath}/post/detail`;
//match
export const match = `${mainPath}/match/listing`;
export const match_view = `${mainPath}/match/detail/:id`;
export const matchview = `${mainPath}/match/detail`;
export const matchlogs = `${mainPath}/match/logs`;
export const match_logs = `${mainPath}/match/logs/:id`;

export const feed= `${mainPath}/feed-report/listing`
//configuration
export const configuration_add = `${mainPath}/configuration/add`;   
//earning
export const earning = `${mainPath}/earning/listing`;
export const earning_view = `${mainPath}/earning/detail/:id`;
export const earningview = `${mainPath}/earning/detail`;
//manage payouts
export const manage_payouts = `${mainPath}/payouts/listing`;
export const manage_payouts_view = `${mainPath}/payouts/detail/:id`;
export const manage_payoutsview = `${mainPath}/payouts/detail`;
//promocode
export const promocode = `${mainPath}/promocode/listing`;
export const promocode_view = `${mainPath}/promocode/detail/:id`;
export const promocode_add = `${mainPath}/promocode/add`;
export const promocode_edit = `${mainPath}/promocode/edit`;
export const promocodeedit = `${mainPath}/promocode/edit/:id`;
export const promocodeview = `${mainPath}/promocode/detail`;
//reports
export const report_list = `${mainPath}/report/list`;

//basic setting
export const basic_setting = `${mainPath}/basic/setting`;
//user_promocode
export const user_promocode = `${mainPath}/user_promocode/listing`;
export const user_promocode_view = `${mainPath}/user_promocode/detail/:id`;
export const userpromocodeview = `${mainPath}/user_promocode/detail`;

//subcategory
export const subcategory_list = `${mainPath}/subcategory/listing`;
export const subcategory = `${mainPath}/subcategory/listing/:id`;
export const subcategory_view = `${mainPath}/subcategory/detail/:id`;
export const subcategory_add = `${mainPath}/subcategory/add`;
export const subcategoryadd = `${mainPath}/subcategory/add/:subId`;
export const subcategory_edit = `${mainPath}/subcategory/edit`;
export const subcategoryedit = `${mainPath}/subcategory/edit/:subId/:id`;
export const subcategoryview = `${mainPath}/subcategory/detail`;

//Support
export const support_list = `${mainPath}/support/list`;

